import { isFocusedStudio } from './appNavigation';

const ENTRY_KEY = 'instanttranscriber_guest_entry';
const METHODS = ['file_picker', 'drop', 'record_button', 'url_form', 'tool_result'];
const ACTIONS = ['upload', 'record', 'url'];
const TTL = 30 * 60 * 1000;

export function embeddedParent() {
  if (typeof window === 'undefined') return null;
  try {
    if (window.parent !== window && window.parent.location.origin === window.location.origin
        && (window.__instantTranscriberEmbeddedAnalytics === true
          || new URLSearchParams(window.location.search).get('embedded') === '1')) return window.parent;
  } catch {}
  return null;
}

export function analyticsAllowed() {
  if (typeof window === 'undefined') return false;
  try {
    const parent = embeddedParent();
    return window.__instantTranscriberAnalyticsConsent !== false
      && window.instantTranscriberAcquisition?.analyticsAllowed?.() !== false
      && (!parent || (parent.__instantTranscriberAnalyticsConsent !== false
        && parent.instantTranscriberAcquisition?.analyticsAllowed?.() !== false));
  } catch { return false; }
}

function cleanEntry(value) {
  if (!value || !ACTIONS.includes(value.guest_entry_action) || !METHODS.includes(value.guest_entry_method)) return {};
  return { guest_entry_action: value.guest_entry_action, guest_entry_method: value.guest_entry_method };
}

export function setGuestEntryContext(action, method) {
  if (!analyticsAllowed()) return;
  const entry = cleanEntry({ guest_entry_action: action, guest_entry_method: method });
  if (!entry.guest_entry_action) return;
  try { sessionStorage.setItem(ENTRY_KEY, JSON.stringify({ ...entry, expires: Date.now() + TTL })); } catch {}
}

export function getGuestAnalyticsContext() {
  if (typeof window === 'undefined') return {};
  const parent = embeddedParent();
  const context = { workspace_mode: parent ? 'embedded' : 'full_page' };
  if (parent && isFocusedStudio()) context.entry_layout = 'focused_dialog';
  if (!analyticsAllowed()) return context;
  try {
    const entry = JSON.parse(sessionStorage.getItem(ENTRY_KEY) || 'null');
    if (entry?.expires > Date.now()) Object.assign(context, cleanEntry(entry));
  } catch {}
  if (parent) {
    // Public SEO paths only; never query strings, source URLs or an auth path.
    const path = parent.location.pathname;
    if (['/', '/de', '/fr', '/de/', '/fr/'].includes(path) || /^\/(?:de\/|fr\/)?(?:transcribe|features|tools|alternatives)\/[a-z0-9-]+\/?$/.test(path)) {
      context.landing_path = path;
      context.landing_locale = ['de', 'fr'].includes(path.split('/')[1]) ? path.split('/')[1] : 'en';
    }
  }
  return context;
}
